import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { Gs1ComponentsLibraryModule } from "@gs1france/gs1-components-library";
import { NgxMatIntlTelInputComponent } from "ngx-mat-intl-tel-input";
import { FooterComponent } from "./components/footer/footer.component";
 import { HeaderComponent } from "./components/header/header.component";
import { HeaderSimplifiedComponent } from "./components/header/headersimplified.component";
import { AppLayoutComponent } from "./components/layout/app-layout.component";
 import { AutoLoginComponent } from "./components/login/autologin.component";
import { LoginComponent } from "./components/login/login.component";
import { MentionsLegalesComponent } from "./components/mentions-legales/mentions-legales.component";
  import { DndDirective } from "./directives/dnd.directive";
import { AuthGuardService } from "./guards/auth-guard.service";
import { TokenGS1Guard } from "./guards/tokenGS1.guard";
 
import { MatStepperModule } from "@angular/material/stepper";
import { MatRadioModule } from "@angular/material/radio";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { PipesModule } from "./Pipe/question/filterquestions.module";
import { TokenAdminGuard } from "../token-admin.guard";
  
@NgModule({
    declarations: [
        FooterComponent, HeaderComponent, HeaderSimplifiedComponent,
         
            AppLayoutComponent,
          LoginComponent, AutoLoginComponent, MentionsLegalesComponent,
         DndDirective
    ],
    imports: [
        Gs1ComponentsLibraryModule, MatIconModule, RouterModule, FormsModule, CommonModule,
        NgSelectModule, NgxMatIntlTelInputComponent, ReactiveFormsModule, MatDialogModule,
        MatTooltipModule, MatAutocompleteModule, NgSelectModule, MatFormFieldModule,
        TranslateModule, MatCheckboxModule, MatStepperModule, MatRadioModule, MatInputModule, MatButtonModule,
        PipesModule
        
    ],
    providers: [
        DndDirective,
        TokenGS1Guard, AuthGuardService,TokenAdminGuard
    ],
    exports: [
        Gs1ComponentsLibraryModule, ReactiveFormsModule, FormsModule, CommonModule, MatDialogModule,
        FooterComponent, HeaderComponent, NgSelectModule, MatTooltipModule,    TranslateModule,PipesModule
    ]
})
export class CoreModule {}
